module.exports = __webpack_public_path__ + "img/restricted-section.4de64bf1.png";